// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2HEK6","buttons":"SendReceipts_buttons__J3kuj","email":"SendReceipts_email__3kn5T","bookApptTitle":"SendReceipts_bookApptTitle__342Js"};